import React, { useMemo, useState } from 'react';
import { Search, Upload, X, Check } from 'react-feather';
import ModalShell from './ModalShell';

const LibraryModal = ({ images, onClose, onSelect, onUploadNew }) => {
	const [q, setQ] = useState('');
	const [selId, setSelId] = useState(null);

	const filtered = useMemo(() => {
		const needle = q.trim().toLowerCase();
		if (!needle) return images;
		return images.filter((l) => (l.name || '').toLowerCase().includes(needle));
	}, [q, images]);

	const selected = filtered.find((l) => l.id === selId);

	return (
		<ModalShell
			onClose={onClose}
			ariaLabel="Logo library"
			className="image-upload-library"
			style={{ maxWidth: 820, maxHeight: 'min(640px, calc(100vh - 48px))' }}
		>
			<div className="image-upload-modal__header">
				<div style={{ flex: 1 }}>
					<div className="image-upload-modal__title">Logo library</div>
					<div className="image-upload-modal__subtitle">
						Previously uploaded logos for this organisation
					</div>
				</div>
				<button
					type="button"
					className="image-upload-modal__btn-primary"
					onClick={onUploadNew}
					style={{ height: 36, padding: '0 14px 0 12px', fontSize: '0.88rem' }}
				>
					<Upload size={16} /> Upload new
				</button>
				<button
					type="button"
					className="image-upload-modal__close"
					onClick={onClose}
					aria-label="Close library"
				>
					<X size={19} />
				</button>
			</div>

			<div className="image-upload-library__toolbar">
				<div className="image-upload-library__search">
					<Search size={16} style={{ color: '#9AA1B3' }} aria-hidden="true" />
					<input
						value={q}
						onChange={(e) => setQ(e.target.value)}
						placeholder="Search logos"
						aria-label="Search logos by name"
					/>
					{q && (
						<button
							type="button"
							className="image-upload-modal__close"
							style={{ width: 22, height: 22 }}
							onClick={() => setQ('')}
							aria-label="Clear search"
						>
							<X size={13} />
						</button>
					)}
				</div>
			</div>

			<div className="image-upload-library__grid-wrap">
				{filtered.length === 0 ? (
					<div className="image-upload-library__empty">
						{q ? `No logos match “${q}”.` : 'No logos in the library yet.'}
					</div>
				) : (
					<div className="image-upload-library__grid">
						{filtered.map((l) => {
							const on = selId === l.id;
							return (
								<button
									key={l.id}
									type="button"
									className={`image-upload-library__card${on ? ' is-selected' : ''}`}
									onClick={() => setSelId(l.id)}
									onDoubleClick={() => onSelect(l)}
									aria-pressed={on}
								>
									<div className="image-upload-library__thumb">
										<img src={l.src} alt={l.name || ''} />
										{on && (
											<span className="image-upload-library__check" aria-hidden="true">
												<Check size={14} />
											</span>
										)}
									</div>
									<div className="image-upload-library__card-text">
										<div className="image-upload-library__card-name">{l.name || 'Untitled'}</div>
										{(l.dims || l.size) && (
											<div className="image-upload-library__card-meta">
												{l.dims}
												{l.dims && l.size ? ' · ' : ''}
												{l.size}
											</div>
										)}
									</div>
								</button>
							);
						})}
					</div>
				)}
			</div>

			<div className="image-upload-modal__footer">
				<div className="image-upload-library__footer-summary">
					{selected ? (
						<span>
							<b style={{ color: '#333B5A' }}>{selected.name || 'Logo'}</b> selected
						</span>
					) : (
						`${filtered.length} logo${filtered.length === 1 ? '' : 's'}`
					)}
				</div>
				<div style={{ marginLeft: 'auto', display: 'flex', gap: 10 }}>
					<button type="button" className="image-upload-modal__btn-secondary" onClick={onClose}>
						Cancel
					</button>
					<button
						type="button"
						className="image-upload-modal__btn-primary"
						disabled={!selected}
						onClick={() => selected && onSelect(selected)}
					>
						Select logo
					</button>
				</div>
			</div>
		</ModalShell>
	);
};

export default LibraryModal;
